module.exports = __webpack_public_path__ + "img/cover3.b6b3a2d7.jpg";